<template>
  <LayoutGradient :title="this.$t('reportEditable.form.titulo_pagina.editar')" icon="fa-editable">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.push({ name: 'vns.report_editable'})">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">      
      <b-form @submit="onSubmit">
        <b-form-group
          :label="$t('reportEditable.form.fields.vns.label')"
          label-for="input-vns"
          :description="$t('reportEditable.form.fields.vns.description')"
        >        
          <b-overlay :show="store_vnss_loading">
            <SelectComponent
                  id="input-vns"
                  :model="vns"
                  :options="store_vnss | idNameToValueLabel"
                  @search="evt => {autocomplete('vns', evt)}"
                  @input="evt => reloadPage(evt)"
              />
          </b-overlay>
        </b-form-group>
        <b-form-group
          :label="$t('reportEditable.form.fields.report_editable.label')"
          label-for="input-report-editable"
          :description="$t('reportEditable.form.fields.report_editable.description')">          
          <b-overlay :show="store_vnss_loading">
            <ExamEditable
                v-for="(examEditable, index) in examsEditable"
                :form="examEditable"
                :key="index"
                :showDescription="examEditable.showDescription"
                @removeExam="removeExam"
                @change="populateExamsEditable"
            />
            <button class="btn btn-sm btn-outline-success"
                    @click="addExam({index: examsEditable.length})"
                    type="button"
            >
                <i class="fa fa-plus"></i>
                {{ $t('reportEditable.form.buttons.adicionar_exame') }}
            </button>
          </b-overlay>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('reportEditable.form.buttons.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ReportEditableRepository from '@/repositories/vns/ReportEditableRepository'
import SelectComponent from "@/components/SelectComponent";
import ExamEditable from "./components/ExamEditable.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ReportEditableForm",
  components: {
    LayoutGradient,
    SelectComponent,
    ExamEditable
  },
  data() {
    return {
      vnsId: null,
      examsEditable: []
    }
  },
  computed: {
    ...mapGetters({
      reportEditables: 'reportEditable/allByVns',
      isLoading: 'reportEditable/isLoading',
      store_vnss: 'vns/allActive',
      store_vnss_loading: 'vns/isLoading',
    }),
    vns() {
      if (this.vnsId && this.store_vnss) {
        const model = this.store_vnss.find(c => this.vnsId === c.id)
        if (model) {
          return {
            value: model.id,
            label: model.name
          }
        }        
      }
      return {}
    },    
    form() {
      return {
        examsEditable: this.examsEditable
      }
    },
  },
  methods: {
    ...mapActions([
      'reportEditable/listByVns',
      'vns/listAllActive',
      'vns/search'
    ]),
    getVnsReportEditable() {
      if (!this.reportEditables.vnsReportEditable) {
        return [];
      }

      let vnsReportEditable = this.reportEditables.vnsReportEditable.map((editable, index) => {
        let tuevs_exam = null;
        if (editable.tuevs_exam) {
          tuevs_exam = {
            value: editable.tuevs_exam.id,
            label: editable.tuevs_exam.name
          }
        }
        return {
          index: index,
          mnemonic: editable.mnemonic,
          tuevs_exam: tuevs_exam
        }
      });

      return vnsReportEditable;
    },
    populateExamsEditable(examEditable) {
      this.form.examsEditable.forEach((element, idx) => {
          if (element.index === examEditable.index) {
            this.form.examsEditable[idx] = examEditable
          }
      });
    },
    async reloadPage(evt) {
      this.vnsId = evt.value;
      this.$router.push({ name: 'vns.report_editable.edit', params: { id: evt.value } });      
      await this['reportEditable/listByVns'](this.vnsId)
      this.examsEditable = this.getVnsReportEditable()
    },
    removeExam(index) {
      this.examsEditable.splice(index, 1);      
      this.examsEditable = this.examsEditable.map((exam, idx) => {
        return { ...exam, index: idx };
      });
    },
    addExam(element) {
      this.examsEditable = [...this.examsEditable, element];
    },
    async onSubmit(evt) {
      evt.preventDefault()
      this.update()
    },
    update() {
      if (!this.vnsId) {
        this.$snotify.error(this.$t('reportEditable.form.update.error_vns_required'))
        return;
      }

      let setExams = new Set();
      for (let i = 0; i < this.form.examsEditable.length; i++) {
          if (!this.form.examsEditable[i].mnemonic || this.form.examsEditable[i].mnemonic.trim() === '') {
              this.$snotify.error(this.$t('reportEditable.form.update.error_mnemonic_required'))
              return;
          }

          if (!this.form.examsEditable[i].tuevs_exam || this.form.examsEditable[i].tuevs_exam === undefined) {
              this.$snotify.error(this.$t('reportEditable.form.update.error_tuevs_exam_required'))
              return;
          }

          setExams.add(this.form.examsEditable[i].tuevs_exam.value);
      }

      if (setExams.size < this.form.examsEditable.length) {
          this.$snotify.error(this.$t('reportEditable.form.update.error_tuevs_exam_repeated'))
          return;
      }

      let examsEditable = this.form.examsEditable.map(exam => {
          return {
            mnemonic: exam.mnemonic,
            tuevs_exam_id: exam.tuevs_exam.value
          }
      });

      ReportEditableRepository.postByVns(this.vnsId, { editables: examsEditable }).then(response => {
        this.$snotify.success(this.$t('reportEditable.form.update.success'))
        this.$router.push({name: 'vns.report_editable'})
      }).catch(error => {
        this.$snotify.error(this.$t('reportEditable.form.update.error'))
        if (error.response.status === 422) {
          ReportEditableRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array, ['vns.status', '=', 1]]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped + '%']        
      ];
    }
  },
  async mounted() {
    await this['reportEditable/listByVns'](this.$route.params.id)
    await this['vns/listAllActive']({filters: [['vns.status', '=', 1]]})
    this.vnsId = this.$route.params.id
    this.examsEditable = this.getVnsReportEditable()
  }
}
</script>

<style lang="scss" scoped>
</style>
